(() => {
  if (window.rtDeferredVideosBound) return;
  window.rtDeferredVideosBound = true;
  const bound = new WeakSet();
  const hydrate = (video) => {
    if (video.dataset.rtVideoLoaded) return;
    video.dataset.rtVideoLoaded = 'true';
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.load();
    if (video.autoplay) video.play().catch(() => {});
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        hydrate(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px', threshold: 0.01 }) : null;
  const bind = (root) => {
    root.querySelectorAll('video[data-rt-deferred-video]').forEach((video) => {
      if (bound.has(video)) return;
      bound.add(video);
      if (observer) observer.observe(video);
      else hydrate(video);
    });
  };
  bind(document);
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
